import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'TicketRedeemItem',
    column_type: 'id',
  },
  created_at: {
    model_name: 'TicketRedeemItem',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'TicketRedeemItem',
    column_type: 'datetime',
  },
  error_message: {
    model_name: 'TicketRedeemItem',
    column_type: 'string',
  },
  update_status: {
    model_name: 'TicketRedeemItem',
    column_type: 'enum',
  },
  redeem_at: {
    model_name: 'TicketRedeemItem',
    column_type: 'datetime',
  },
  ticket: {
    model_name: 'TicketRedeemItem',
    column_type: 'belongs_to',
    extra: {
      association_name: 'ticket',
      model_name: 'Ticket',
      foreign_key: 'ticket_id',
    },
  },
  ticket_id: {
    model_name: 'TicketRedeemItem',
    column_type: 'belongs_to',
    extra: {
      association_name: 'ticket',
      model_name: 'Ticket',
      foreign_key: 'ticket_id',
    },
  },
  ticket_serial_code: {
    model_name: 'TicketRedeemItem',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
